import type { Bucket, SearchFilters } from '../types';
import type { FilterCounts } from '../../../graphql/fetchProspectsWithPaginationByJobId';
import jobApplicationService from '../../../services/jobApplicationService';
import { logError } from '../../../utils/logError';

import type { Language } from '@seek/melways-sites';

const getCountsForFilters = async (
  jobId: number,
  searchText: string,
  language: Language,
  displayCountry: string,
  bucket: Bucket,
  sortBy: string,
  pageNumber: number = 1,
  filters: SearchFilters,
): Promise<FilterCounts | undefined> => {
  try {
    const searchJobApplicationResult = await jobApplicationService.fetch(
      jobId,
      searchText,
      language,
      displayCountry,
      bucket as any,
      sortBy,
      pageNumber,
      filters,
    );

    if (searchJobApplicationResult.source === 'cm-graph') {
      return searchJobApplicationResult.data.filterCounts;
    }

    if (searchJobApplicationResult.data === 'redirect') {
      return;
    }

    return {
      rrFilterCounts:
        searchJobApplicationResult.data.filterCounts.questionnaireFilterCounts.map(
          ({ id, count }) => ({ id, count }),
        ),
    };
  } catch (error: any) {
    logError(
      {
        errorCode: 'GET_FILTER_COUNTS',
        description: 'Error attempting: jobApplicationService.fetch',
      },
      {
        error,
        jobId,
        bucket,
        sortBy,
        pageNumber,
        filters,
        searchText,
      },
    );
    return;
  }
};

export default getCountsForFilters;
